module.exports = {
    /*_API: 'https://myapi.inspecthoa.com/api/v1.1/property/report_data',*/
    _API: 'https://myapi.inspecthoa.com/api/v1.1/property/report_data',
    _TOKEN:'abcd',
};
